import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_USUARIOS

export default class ContratosService {
  paginate () {
    return http.get(`${baseUrl}/contratos/listar`, {
      headers: {
        loading: true
      }
    })
  }
}
